import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";

function Sortings(props) {
  function renderSorting(sorting, sortingIndex) {
    return (
      <Dropdown.Item
        onClick={() => toggleSorting(sortingIndex)}
        key={sorting.id}
      >
        {sorting.active ? (
          <i className="fa fa-check align-middle mr-2 text-primary"></i>
        ) : null}
        {sorting.title}
      </Dropdown.Item>
    );
  }

  function toggleSorting(sortingIndex) {
    let result = [];
    if (sortings[sortingIndex].active) {
      sortings[sortingIndex].active = false;
    } else {
      sortings.forEach((sorting) => (sorting.active = false));
      sortings[sortingIndex].active = true;
      result = sortings[sortingIndex].value;
    }
    changeSortingsState(JSON.stringify(sortings));
    props.changeFn(result);
  }

  let [sortingsJSON, changeSortingsState] = useState(
    JSON.stringify(props.sortings || {})
  );
  let sortings = JSON.parse(sortingsJSON);

  if (!props.sortings) return null;

  let sortTitle = <i className="icon-sm fa fa-sort-amount-asc p-0"></i>;
  let label = "";
  sortings.forEach((sorting) => {
    if (sorting.active) label = sorting.title;
  });
  return (
    <Dropdown className="d-inline-block align-middle ">
      <Dropdown.Toggle variant="light">
        {sortTitle} <span className="text-primary">{label}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {sortings.map((sorting, sortingIndex) =>
          renderSorting(sorting, sortingIndex)
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}
export default Sortings;
